import { render, staticRenderFns } from "./PaymentOrder.vue?vue&type=template&id=df573162&scoped=true"
import script from "./PaymentOrder.vue?vue&type=script&lang=js"
export * from "./PaymentOrder.vue?vue&type=script&lang=js"
import style0 from "./PaymentOrder.vue?vue&type=style&index=0&id=df573162&lang=css"
import style1 from "./PaymentOrder.vue?vue&type=style&index=1&id=df573162&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df573162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df573162')) {
      api.createRecord('df573162', component.options)
    } else {
      api.reload('df573162', component.options)
    }
    module.hot.accept("./PaymentOrder.vue?vue&type=template&id=df573162&scoped=true", function () {
      api.rerender('df573162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PaymentOrder/PaymentOrder.vue"
export default component.exports